module.exports = __webpack_public_path__ + "static/media/intelig-compet.62cac1ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentines_day/intelig-compet.png
// module id = 314
// module chunks = 0